var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hococo-header-button",class:_vm.buttonClass,on:{"click":_vm.addParticipant}},[_c('i',{staticClass:"far fa-user-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }